module.exports = __webpack_public_path__ + "static/img/default_picture.84999b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default_picture.png
// module id = VY7K
// module chunks = 28